<!-- not working unsafe and they are true -->
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48" #icon>
  <title>dots 05</title>
  <g class="nc-icon-wrapper" stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#86bc25"
    stroke="#86bc25">
    <g class="nc-loop_dots-05-48">
      <circle fill="none" stroke="#000000" stroke-miterlimit="10" cx="6" cy="25" r="4"
        transform="translate(0 3.896449999999822)" />
      <circle data-color="color-2" fill="none" stroke-miterlimit="10" cx="24" cy="25" r="4"
        transform="translate(0 5.896449999999822)" />
      <circle fill="none" stroke="#000000" stroke-miterlimit="10" cx="42" cy="25" r="4"
        transform="translate(0 0)" />
    </g>
  </g>
</svg>

